import { Theme } from '@mui/material/styles';

export const modalStyles = {
  drawer: {
    width: { xs: '100%', md: 386 },
    borderRadius: { xs: 0, md: 2 },
    maxHeight: 'none',
    '@media (pointer: coarse)': { '& input, & .MuiSelect-select': { fontSize: 16 } },
    '& .MuiIconButton-root': { minHeight: { xs: 44, md: 0 }, minWidth: { xs: 44, md: 0 } },
    backgroundColor: (theme: Theme) => theme.palette.background.paper,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    pt: { xs: 'env(safe-area-inset-top)', md: 0 },
    pb: { xs: 'env(safe-area-inset-bottom)', md: 0 },
  },
  header: {
    p: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tabsContainer: {
    borderBottom: 1,
    borderColor: 'divider',
  },
  tab: {
    borderBottom: 1,
    borderColor: 'divider',
  },
  content: {
    p: 2,
    minHeight: 0,
    overflowY: 'auto',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: 2,
    backgroundColor: 'grey.100',
    borderRadius: 2,
    p: 3,
    height: '100%',
  },
};

export const phoneInputStyles = {
  fieldsContainer: {
    mb: 3,
    display: 'flex',
    gap: 1,
  },
  countryPaper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    overflow: 'hidden',
    boxShadow: 'none',
  },
  numberPaper: {
    flex: 2,
    display: 'flex',
    alignItems: 'center',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    overflow: 'hidden',
    boxShadow: 'none',
  },
  countrySelect: {
    px: 1,
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiSelect-icon': {
      right: (theme: Theme) => theme.spacing(0.5),
    },
  },
  countryDisplay: {
    display: 'flex',
    alignItems: 'end',
  },
  countryText: {
    fontWeight: 500,
    color: 'text.primary',
  },
  numberInput: {
    flex: 1,
    px: 2,
    py: 1,
    fontSize: { xs: '16px', md: '14px' },
    '& input': {
      py: 0.5,
    },
  },
  clearButton: {
    mr: 1,
    backgroundColor: 'grey.100',
    width: 24,
    height: 24,
    '&:hover': {
      backgroundColor: 'grey.200',
    },
  },
};

export const keypadStyles = {
  container: {
    p: (theme: Theme) => ({ xs: 0, md: theme.spacing(0, 4, 0, 3) }),
  },
  gridItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  keyButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    padding: 1,
    height: 52,
    width: 52,
    borderRadius: '50%',
    backgroundColor: (theme: Theme) => theme.palette.grey[300],
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: (theme: Theme) => theme.palette.grey[400],
    },
  },
  keyNumber: {
    variant: 'h6',
  },
  keyLetters: {
    variant: 'caption',
    sx: { lineHeight: 1 },
  },
};

export const callButtonStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    mt: 3,
  },
  fab: {
    width: 56,
    height: 56,
    '&:hover': {
      transform: 'scale(1.05)',
    },
    '&:active': {
      transform: 'scale(0.95)',
    },
    transition: 'all 0.2s ease',
  },
};
